import { mapValue } from "Utilities";

export default function getZoomValues(_focus, _scale) {
    const focus = _focus;
    const scale = _scale;

    if (!focus || isNaN(scale)) return false;

    const [xStr, yStr] = focus.split(",");
    const xPercent = parseFloat(xStr) / 100;
    const yPercent = parseFloat(yStr) / 100;

    const mod = scale / 2;
    const x = mapValue(xPercent, 0, 1, 100, -100) * mod;
    const y = mapValue(yPercent, 0, 1, 100, -100) * mod;

    return {
        x: x,
        y: y,
        scale: scale,
    };
}
